export default __webpack_public_path__ + "static/AD_9551_rgb-cf3b4adb9ca9364b13f0a6c459c4cbdf.jpg";